import Icon from '@mdi/react'
import { ComponentProps, useState } from 'react'

import { Button, IconButton } from '@/components/ui/button'
import { Tooltip } from '@/components/ui/tooltip'
import useColorModeValue from '@/hooks/useColorModeValue'

const SquareButton = ({
    isDisabled,
    icon,
    onClick,
    label,
    dataID,
    tooltipPosition,
    isIconButton,
    dataTestId,
}: {
    isDisabled: boolean
    icon: string
    onClick: () => void
    label: string
    dataID?: string
    tooltipPosition: NonNullable<ComponentProps<typeof Tooltip>['positioning']>['placement']
    isIconButton?: boolean
    dataTestId?: string
}) => {
    const [isHover, setIsHover] = useState(false)
    const iconColor = useColorModeValue(
        isHover ? 'var(--chakra-colors-white)' : 'var(--chakra-colors-dark-700)',
        isHover ? 'var(--chakra-colors-dark-700)' : 'var(--chakra-colors-white)',
    )
    const buttonColor = useColorModeValue(
        isHover ? 'var(--chakra-colors-dark-700)' : 'var(--chakra-colors-white)',
        isHover ? 'var(--chakra-colors-white)' : 'var(--chakra-colors-dark-700)',
    )
    const handleMouseEnter = () => {
        setIsHover(true)
    }

    const handleMouseLeave = () => {
        setIsHover(false)
    }

    // unmountOnExit is set to false as to avoid flickering
    return (
        <Tooltip positioning={{ placement: tooltipPosition }} content={label} variant="gsk" unmountOnExit={false}>
            {isIconButton ? (
                <IconButton
                    disabled={isDisabled}
                    variant="squareNoBorder"
                    data-id={dataID}
                    aria-label={label}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onClick={onClick}
                    icon={<Icon path={icon} size="20px" color={iconColor} />}
                    data-testid={dataTestId}
                />
            ) : (
                <Button
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    bg={buttonColor}
                    disabled={isDisabled}
                    data-id={dataID}
                    variant="square"
                    onClick={onClick}
                    data-testid={dataTestId}
                    aria-label={label}
                >
                    <Icon path={icon} size="20px" color={iconColor} />
                </Button>
            )}
        </Tooltip>
    )
}

export default SquareButton
